import axios from "axios"

const actionGetPartners = async ({commit}, payload) => {
  let query = {};
  if(payload?.name || payload?.page || payload?.email || payload?.code || payload?.status) {
    query = {...payload}
  } else {
    query = {farm:payload}
  }
  let partners = await axios.get(`${process.env.VUE_APP_URL_API}/v1/people/get_partners`, {params:query});
  commit("SET_PARTNERS", partners.data);
}

const actionSavePartner = async (_, payload) => {
  await axios.post(`${process.env.VUE_APP_URL_API}/v1/people`, {person:payload});
}

const actionEditPartner = async (_, payload) => {
  await axios.put(`${process.env.VUE_APP_URL_API}/v1/people/${payload.id}`, {person:payload});
}

export default {
  actionGetPartners,
  actionSavePartner,
  actionEditPartner
}